
export enum CredStatCd {
	BANK_RUPTURE = 'BankRupture',
	CASH = 'Cash',
	CREDIT = 'Credit',
	NO_CREDIT = 'NoCredit',
	VOLUNTARY = 'Voluntary'}

